import * as React from "react";
const SvgFiRrSecurity = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-security_svg__a)">
      <path
        fill="#062147"
        d="M23.983 21.926a32.7 32.7 0 0 0-.608-5.545A3 3 0 0 0 20.439 14h-2.1l-.3-3.635.391-.042a3.007 3.007 0 0 0 2.29-4.238C19.084 2.559 14.786 0 10.5 0A10.51 10.51 0 0 0 0 10.5c.081 1.73.277 3.452.587 5.155a4.99 4.99 0 0 0 3.457 3.989c.514.161 1.02.311 1.519.458 1.406.37 2.778.86 4.1 1.467.564.282 1.185.43 1.816.431a3.98 3.98 0 0 0 2.777-1.123l1.1-.877h1.475l.071.855a2.98 2.98 0 0 0 2.137 2.631q1.454.344 2.94.514a2.013 2.013 0 0 0 2-2.074zM20.439 16a.994.994 0 0 1 .977.783c.061.3.138.709.215 1.217h-2.964l-.167-2zm-4.11-2h-3.024a2.89 2.89 0 0 1 .879-2.663c.416-.381.936-.63 1.494-.716l.367-.04zm-3.445 5.422a2.02 2.02 0 0 1-2.329.357 26.6 26.6 0 0 0-4.425-1.594c-.487-.145-.983-.291-1.485-.45a3 3 0 0 1-2.082-2.394c-.29-1.6-.477-3.217-.563-4.841A8.51 8.51 0 0 1 10.5 2c3.489 0 7.1 2.118 8.406 4.927a1.01 1.01 0 0 1-.732 1.412l-2.747.3a4.874 4.874 0 0 0-3.564 7.181l1.692 3.058zM15.355 18l-1.106-2H16.5l.166 2zm4.245 3.567a.99.99 0 0 1-.707-.878l-.06-.689h3.034c.053.608.094 1.277.113 2a12 12 0 0 1-2.38-.433M10 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-security_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSecurity;
